import { render } from "./MenuPage.vue?vue&type=template&id=1988905c"
import script from "./MenuPage.vue?vue&type=script&lang=js"
export * from "./MenuPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__